import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://api-fornecedores.centraomateriais.com';
export const TOKEN_KEY = 'for_token';
// Sessão do admin guardada enquanto ele usa o "Ver como" (volta pra ela ao sair).
export const TOKEN_ADMIN_KEY = 'for_token_admin';

const api = axios.create({ baseURL: API_URL });

// Anexa o token em toda requisição
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Sessão expirada -> volta pro login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Venceu a visualização ("Ver como", 1h): volta pra conta do admin em vez de deslogar.
      const admin = localStorage.getItem(TOKEN_ADMIN_KEY);
      localStorage.removeItem(TOKEN_ADMIN_KEY);
      if (admin) {
        localStorage.setItem(TOKEN_KEY, admin);
        window.location.href = '/';
      } else {
        localStorage.removeItem(TOKEN_KEY);
        if (window.location.pathname !== '/login') window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
